import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const LanguageSwitcher = () => {
  const [language, setLanguage] = useState('en');

  const { i18n } = useTranslation();

  const handleLanguageToggle = () => {
    const newLanguage = language === 'en' ? 'es' : 'en';
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  return (
    <div className='flex items-center justify-center gap-x-2'>
      <p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">EN</p>

      <label className="switch">
        <input type="checkbox" onClick={handleLanguageToggle}/>
        <span className="slider"></span>
      </label>

      <p className="text-base font-medium text-gray-500 hover:text-gray-900 cursor-pointer no-selection">ES</p>
    </div>
  );
}

export default LanguageSwitcher;
